import { AnyAction } from 'redux'
import * as type from '@app/constants/myEnergy/myEnergy'

export interface IMyEnergyState {
  currentTab: string,
}

const initialState: IMyEnergyState = {
  currentTab: 'energy',
}

const myEnergy = (
  state: IMyEnergyState = initialState,
  action: AnyAction,
): IMyEnergyState => {
  switch (action.type) {
  case type.CHOOSE_TAB: {
    return {
      ...state,
      currentTab: action.chosenTab,
    }
  }

  case type.RESET_MY_ENERGY:
    return initialState
  default:
    return state
  }
}

export default myEnergy
